var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable, observable } from "mobx";
//The goal of this store is to slowly replace ModuleAgent/store-agent, isolating pure domain logic from the UI logic.
export class UserStore {
    constructor() {
        this.agentId = "";
        this.meUserId = "";
        this.agentDbId = "";
        this.teamId = "";
        this.orgId = "";
        this.isMaskSensitiveDataOrgSettingEnabled = false;
        this.channels = {
            voiceCount: 0,
            chatCount: 0,
            emailCount: 0,
            socialCount: 0,
            maVoiceCount: 0,
            maChatCount: 0,
            maEmailCount: 0,
            maSocialCount: 0
        };
        makeObservable(this);
    }
}
__decorate([
    observable
], UserStore.prototype, "agentId", void 0);
__decorate([
    observable
], UserStore.prototype, "meUserId", void 0);
__decorate([
    observable
], UserStore.prototype, "agentDbId", void 0);
__decorate([
    observable
], UserStore.prototype, "teamId", void 0);
__decorate([
    observable
], UserStore.prototype, "orgId", void 0);
__decorate([
    observable
], UserStore.prototype, "isMaskSensitiveDataOrgSettingEnabled", void 0);
__decorate([
    observable
], UserStore.prototype, "channels", void 0);
